import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Scrollbars } from 'react-custom-scrollbars';
import { systolicBloodPressurePk, diastolicBloodPressurePk, plotColors } from 'config.jsx';
import MeasureSelectionHelper from './MeasureSelectionHelper';

const styles = {
  table: {
    height: '250px',
    fixedHeader: true,
  },
  head: {
    backgroundColor: '#fff',
    position: 'sticky',
    top: 0,
  },
  measureSelection: {
    backgroundColor: '#fff',
    height: '250px',
  },
  centeredDiv: {
    display: 'flex',
    alignItems: 'left',
  },
  fullHeight: {
    height: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    margin: '15px',
  },
  panel: {
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  panelSummary: {
    display: 'flex',
    justifyContent: 'center !important',
    minHeight: '16px !important',
    height: '50px',
    order: '1',
  },
  panelHeader: {
    textAlign: 'right',
    flexGrow: '1',
  },
  noPadding: {
    padding: 0,
  },
};

const bloodPressureCombinationMeasureCodePk = -1;
const whiteBloodCellCombinationMeasureCodePk = -2;

export class MeasureSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unselectedMeasureCodes: [],
      selectedMeasureCodes: [],
      bloodPressureMeasureCodes: [],
      differentPlotDisabled: true,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.selectMeasureCode = this.selectMeasureCode.bind(this);
    this.removeSelectedMeasureCode = this.removeSelectedMeasureCode.bind(this);
    this.getMeasureCodes = this.getMeasureCodes.bind(this);
    this.plotCorrelationPlot = this.plotCorrelationPlot.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.sortMeasureCodes = this.sortMeasureCodes.bind(this);
  }

  componentDidMount() {
    this.getMeasureCodes();
  }

  getMeasureCodes() {
    const { measureCodes } = this.props;
    const unselectedMeasureCodes = [...measureCodes];
    let bloodPressureMeasureCodes;
    if (measureCodes.map(measureCode => measureCode.pk).includes(systolicBloodPressurePk)
      && measureCodes.map(measureCode => measureCode.pk).includes(diastolicBloodPressurePk)) {
      bloodPressureMeasureCodes = MeasureSelectionHelper
        .combineBloodPressures(unselectedMeasureCodes);
      this.sortMeasureCodes(unselectedMeasureCodes);
    }
    if (measureCodes.filter(measureCode => measureCode.class_field === 'immunology').length === 6) {
      MeasureSelectionHelper.addBloodCellCombination(unselectedMeasureCodes);
      this.sortMeasureCodes(unselectedMeasureCodes);
    }
    this.setState({
      unselectedMeasureCodes,
      bloodPressureMeasureCodes,
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { getMeasures, getMeasuresWithBloodPressure, getBloodCellMeasures } = this.props;
    const { bloodPressureMeasureCodes, selectedMeasureCodes } = this.state;
    if (selectedMeasureCodes.map(measureCode => measureCode.pk)
      .includes(whiteBloodCellCombinationMeasureCodePk)) {
      getBloodCellMeasures();
    } else if (selectedMeasureCodes.map(measureCode => measureCode.pk)
      .includes(bloodPressureCombinationMeasureCodePk)) {
      const selectedMeasureCodesWithBloodPressure = MeasureSelectionHelper
        .addBloodPressureMeasureCodes(selectedMeasureCodes, bloodPressureMeasureCodes);
      getMeasuresWithBloodPressure(selectedMeasureCodesWithBloodPressure);
    } else {
      getMeasures(selectedMeasureCodes);
    }
  }

  handleClick() {
    const { toggleMeasureSelectionExpanded, measureSelectionExpanded } = this.props;
    toggleMeasureSelectionExpanded(!measureSelectionExpanded);
  }

  plotCorrelationPlot(event) {
    event.preventDefault();
    const { selectedMeasureCodes } = this.state;
    const { getMeasuresForCorrelationPlot } = this.props;
    getMeasuresForCorrelationPlot(selectedMeasureCodes);
  }

  selectMeasureCode(event, measureCode) {
    const { unselectedMeasureCodes, selectedMeasureCodes } = this.state;
    let differentPlotDisabled = true;
    if (selectedMeasureCodes.length >= 2
      || selectedMeasureCodes.map(measure => measure.pk)
        .includes(whiteBloodCellCombinationMeasureCodePk)) return;
    if (selectedMeasureCodes.length === 1 && measureCode.pk === -2) return;
    if (selectedMeasureCodes.length === 1
      && measureCode.pk !== bloodPressureCombinationMeasureCodePk
      && selectedMeasureCodes[0].pk !== bloodPressureCombinationMeasureCodePk) {
      differentPlotDisabled = false;
    }
    const filteredUnselectedMeasureCodes = unselectedMeasureCodes
      .filter(unselectedMeasureCode => unselectedMeasureCode !== measureCode);
    this.setState(
      {
        unselectedMeasureCodes: filteredUnselectedMeasureCodes,
        selectedMeasureCodes: [...selectedMeasureCodes, measureCode],
        differentPlotDisabled,
      },
    );
  }

  removeSelectedMeasureCode(event, measureCode) {
    const { unselectedMeasureCodes, selectedMeasureCodes } = this.state;
    const filteredSelectedMeasureCodes = selectedMeasureCodes
      .filter(selectedMeasureCode => selectedMeasureCode !== measureCode);
    const sortedUnselectedMeasureCodes = [...unselectedMeasureCodes, measureCode];
    this.sortMeasureCodes(sortedUnselectedMeasureCodes);
    this.setState(
      {
        unselectedMeasureCodes: sortedUnselectedMeasureCodes,
        selectedMeasureCodes: filteredSelectedMeasureCodes,
        differentPlotDisabled: true,
      },
    );
  }

  sortMeasureCodes(measureCodes) {
    measureCodes.sort((a, b) => {
      if (a.label.orderNumber < b.label.orderNumber) return -1;
      if (a.label.orderNumber > b.label.orderNumber) return 1;
      return 0;
    });
  }

  render() {
    const {
      unselectedMeasureCodes, selectedMeasureCodes, differentPlotDisabled,
    } = this.state;
    const {
      classes, measureSelectionExpanded,
    } = this.props;
    return (
      <div>
        <ExpansionPanel expanded={measureSelectionExpanded} className={classes.panel}>
          <ExpansionPanelSummary
            className={classes.panelSummary}
            onClick={this.handleClick}
            expandIcon={<FontAwesomeIcon icon="angle-down" />}
          >
            <div className={classes.panelHeader}>
              {measureSelectionExpanded ? 'Hide measure selection' : 'Show measure selection'}
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.noPadding}>
            <Grid container justify="space-between" className={classes.measureSelection}>
              <Grid item xs={6} sm={5}>
                <div className={classes.table}>
                  <Scrollbars thumbSize={80}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.head}>
                            {'Available measure data'}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {unselectedMeasureCodes.map(measureCode => (
                          <TableRow
                            key={measureCode.pk}
                            onClick={event => this.selectMeasureCode(event, measureCode)}
                          >
                            <TableCell>
                              {measureCode.label.name}
                              {', '}
                              {measureCode.class_field}
                              {', '}
                              {measureCode.descript.toLowerCase()}
                            </TableCell>
                          </TableRow>
                        ))}
                        {
                          unselectedMeasureCodes.length === 0 && (
                            <TableRow>
                              <TableCell>
                                {'No available measure data'}
                              </TableCell>
                            </TableRow>
                          )
                        }
                      </TableBody>
                    </Table>
                  </Scrollbars>
                </div>
              </Grid>
              <Grid item xs={6} sm={5}>
                <div className={classes.fullHeight}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          {'Selected'}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedMeasureCodes.map((measureCode, index) => (
                        <TableRow
                          key={measureCode.pk}
                          onClick={event => this.removeSelectedMeasureCode(event, measureCode)}
                        >
                          <TableCell style={{ color: plotColors[index] }}>
                            {measureCode.label.name}
                            {', '}
                            {measureCode.class_field}
                            {', '}
                            {measureCode.descript.toLowerCase()}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <div className={classes.centeredDiv}>
                    <Button
                      variant="contained"
                      className={classes.button}
                      onClick={this.handleSubmit}
                      disabled={selectedMeasureCodes.length < 1}
                    >
                      {'Plot'}
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.button}
                      onClick={this.plotCorrelationPlot}
                      disabled={differentPlotDisabled}
                    >
                      {'Correlation'}
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }
}

MeasureSelection.propTypes = {
  getMeasures: PropTypes.func.isRequired,
  getMeasuresWithBloodPressure: PropTypes.func.isRequired,
  getBloodCellMeasures: PropTypes.func.isRequired,
  getMeasuresForCorrelationPlot: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
  measureCodes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  measureSelectionExpanded: PropTypes.bool.isRequired,
  toggleMeasureSelectionExpanded: PropTypes.func.isRequired,
};

export default withStyles(styles)(MeasureSelection);



// WEBPACK FOOTER //
// ./src/components/health-graph/MeasureSelection.jsx